import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

/**
 * Composable hook for managing package cache.
 *
 * Handles `['packages', params]` (list) and `['package', { packageId }]` (single) queries.
 */
export const usePackageCacheManager = () => {
  const queryClient = useQueryClient();

  /**
   * Invalidate all package list queries.
   */
  const invalidatePackages = useCallback(async () => {
    await queryClient.invalidateQueries({
      predicate: query => {
        const [key] = query.queryKey as [unknown];
        return key === 'packages';
      },
    });
  }, [queryClient]);

  /**
   * Invalidate a single package query.
   */
  const invalidatePackage = useCallback(
    async (packageId: string) => {
      await queryClient.invalidateQueries(['package', { packageId }]);
    },
    [queryClient],
  );

  return { invalidatePackages, invalidatePackage };
};
